import axios from "axios";
import API from "@/core/api";

export default ({ requiresAuth = false } = {}) => {
  const options = {};
  options.baseURL = API.API_URL;
  options.headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  if (requiresAuth) {
    const token = localStorage.getItem("token");
    if (token) {
      options.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("Warning: requiresAuth is true but no token found in localStorage");
    }
  }

  const instance = axios.create(options);

  // Add request interceptor to append api_token to query params
  instance.interceptors.request.use(config => {
    const token = localStorage.getItem("token");
    if (token) {
      config.params = config.params || {};
      config.params.api_token = token;
    }
    return config;
  });

  // Add response interceptor to handle 401 errors
  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        console.error("401 Unauthorized: Token may be expired or invalid");
        // Optionally clear token and redirect to login
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        // Uncomment to auto-redirect on 401
        // window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );

  return instance;
};
